import { get, includes, map, startCase } from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Card } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { ReactComponent as PurchaseOrdersSVG } from '../../Assets/icons/purchaseorders.svg';
import { ReactComponent as RequestedItemsSVG } from '../../Assets/icons/requesteditems.svg';
import { ReactComponent as InvoicesSvg } from '../../Assets/icons/invoices.svg';
import { ReactComponent as PaymentsSVG } from '../../Assets/icons/payments.svg';
import { ReactComponent as ProfileSVG } from '../../Assets/icons/profile.svg';
import { ReactComponent as CreditsSVG } from '../../Assets/icons/credits.svg';
import { ReactComponent as DeliveriesSVG } from '../../Assets/icons/deliveries.svg';
import whiteList from '../../Lib/Constants/self-schedule-whitelist';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    padding: '15px',
  },
  card: {
    boxShadow: '-11px 9px 21px 0 rgba(173, 182, 217, 0.17)',
    borderRadius: '12px',
    display: 'flex',
    flex: '1',
    minHeight: '260px',
  },
  link: {
    alignItems: 'space-around',
    display: 'flex',
    color: get(theme, 'palette.primary.main'),
    flex: '1',
    flexDirection: 'column',
    padding: '30px',
    textDecoration: 'none',
    '& h3': {
      flex: '1',
      margin: '0px',
    },
  },
  icon: {
    height: '80px',
    marginLeft: '-14px',
    width: 'auto',
  },
  iconContainer: {
    flex: '1',
    display: 'flex',
  },
}));

const icons = [
  ProfileSVG,
  PurchaseOrdersSVG,
  RequestedItemsSVG,
  DeliveriesSVG,
  InvoicesSvg,
  CreditsSVG,
  PaymentsSVG,
];
const pages = map(
  [
    {
      link: 'profile',
      name: 'Profile & Attributes',
      params: '',
    },
    {
      link: 'purchase-orders',
      name: 'Purchase orders',
      params: '',
    },
    {
      link: 'requested-items',
      name: 'Requested Items',
      params: '',
    },
    {
      link: 'deliveries',
      name: 'Deliveries',
      params: '',
    },
    {
      link: 'invoices',
      name: 'Invoices',
      params: 'search=',
    },
    {
      link: 'credits',
      name: 'Credits',
      params: '',
    },
    {
      link: 'payments',
      name: 'Payments',
      params: '',
    },
  ],
  ({ link, params, name }, key) => ({
    link,
    key,
    icon: icons[key],
    params,
    name,
  }),
);

export default function QuickLinks(props) {
  const { classes } = useStyles();
  const { userId, vendor } = props;

  return (
    <div className={classes.root}>
      {pages
        .filter((page) => {
          // REMOVE LATER - Whitelisting deliveries for vendors
          // Also in the sidebar
          if (page.name !== 'Deliveries') return true;

          if (includes(whiteList, vendor.email)) {
            return true;
          }

          return false;
          // Remove the entire filtering when
          // Deliveries and Requested Items are live for all
        })
        .map((page) => {
          const LinkIcon = page.icon;

          return (
            <Card key={page.link} className={classes.card}>
              <Link
                className={classes.link}
                to={`/users/${userId}/${page.link}`}
              >
                <h3>{page.name.split('&').map(startCase).join(' & ')}</h3>
                <div>
                  <LinkIcon className={classes.icon} />
                </div>
              </Link>
            </Card>
          );
        })}
    </div>
  );
}

QuickLinks.propTypes = {
  userId: PropTypes.string.isRequired,
  vendor: PropTypes.shape({}).isRequired,
};
